<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('销售订单.订单编号')" prop="id">
                <a-input v-model="queryParam.id" @pressEnter="handleQuery" :maxLength="18"
                  :placeholder="$t('通用.输入.请输入') + $t('销售订单.订单编号')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('销售订单.买家名称')" prop="buyerName">
                <a-input v-model="queryParam.buyerName" @pressEnter="handleQuery" :maxLength="20"
                  :placeholder="$t('通用.输入.请输入') + $t('销售订单.买家名称')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('价格审核.申请开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                  :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('价格审核.申请结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                  :show-time="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('价格审核.状态')" prop="modifyStatus">
                <a-select  :placeholder="$t('通用.输入.请选择') + $t('价格审核.状态')" style="width: 100%"
                  v-model="queryParam.modifyStatus" allowClear>
                  <a-select-option v-for="(item, index) in options" :value="item.type"
                    :key="index">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery">
                  <a-icon type="search" />{{ $t('通用.按钮.查询') }}
                </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery">
                  <a-icon type="redo" />{{ $t('通用.按钮.重置') }}
                </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
          :refresh-loading="loading" @refresh="getList" />
      </div>
      <!-- 数据展示 -->
      <a-table  :loading="loading" :size="tableSize" rowKey="applyId" :columns="columns"
        :data-source="list" :pagination="false" :bordered="tableBordered">
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.modifyCreateTime) }}
        </span>
        <span slot="payAmount" slot-scope="text, record">
          ¥{{ record.payAmount }}
        </span>
        <span slot="pendingPayAmount" slot-scope="text, record">
          <span style="color: #f50; font-weight: bold">¥{{ record.pendingPayAmount }}</span>
        </span>
        <span slot="modifyStatus" slot-scope="text, record">
          <a-tag :color="record.modifyStatus === 0 ? 'orange' : (record.modifyStatus === 1 ? 'green' : 'red')">
            {{ record.modifyStatus === 0 ? '待审批' : (record.modifyStatus === 1 ? '已通过' : '已拒绝') }}
          </a-tag>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="handleApprove(record)">
            {{ record.modifyStatus === 0 ? $t('售后订单.审核') : '查看' }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum" :total="total" :page-size="queryParam.pageSize"
        :showTotal="(total) => getTotal(total)" @showSizeChange="onShowSizeChange" @change="changeSize" />
    </a-card>
    <!-- 审批弹窗 -->
    <a-modal width="760px" :visible="approveModalVisible" @cancel="approveModalCancel" :footer="null"
      :destroyOnClose="true">
      <a-divider orientation="left">
        <b>{{ $t('售后订单.审核') }}</b>
      </a-divider>
      <a-form-model ref="approveForm" :model="approveForm" :rules="approveRules" :label-col="{ span: 5 }"
        :wrapper-col="{ span: 17 }" class="myForm">
        <a-form-model-item :label="$t('销售订单.订单编号')">
          <span>{{ approveRecord.id }}</span>
        </a-form-model-item>
        <a-form-model-item :label="$t('销售订单.买家名称')">
          <span>{{ approveRecord.buyerName }}</span>
        </a-form-model-item>
        <a-form-model-item :label="$t('销售订单.当前金额')">
          <span>¥{{ approveRecord.payAmount }}</span>
        </a-form-model-item>
        <a-form-model-item :label="$t('销售订单.申请金额')">
          <span style="color: #f50; font-weight: bold">¥{{ approveRecord.pendingPayAmount }}</span>
        </a-form-model-item>
        <a-form-model-item :label="$t('销售订单.申请备注')">
          <span>{{ approveRecord.modifyRemark || '-' }}</span>
        </a-form-model-item>
        <a-divider orientation="left">
          <b>商品单价明细</b>
        </a-divider>
        <a-table :data-source="approveRecord.modifyPriceItemList || []" row-key="orderItemId" :pagination="false"
          size="small" bordered style="margin-bottom: 16px;">
          <a-table-column title="商品名称" data-index="goodsName" width="240px" />
          <a-table-column title="数量" data-index="goodsCount" width="70px" align="center" />
          <a-table-column title="原成交单价" width="110px" align="right">
            <template slot-scope="text, row">¥{{ row.oldPayPrice }}</template>
          </a-table-column>
          <a-table-column title="修改后单价" width="110px" align="right">
            <template slot-scope="text, row"><span style="color: #f50; font-weight: bold">¥{{ row.newPayPrice }}</span></template>
          </a-table-column>
          <a-table-column title="单价变动" width="110px" align="right">
            <template slot-scope="text, row">
              <span :style="{ color: (Number(row.newPayPrice) - Number(row.oldPayPrice)) >= 0 ? '#52c41a' : '#f50' }">
                {{ (Number(row.newPayPrice) - Number(row.oldPayPrice)) >= 0 ? '+' : '' }}{{ Number((Number(row.newPayPrice) - Number(row.oldPayPrice)).toFixed(2)) }}
              </span>
            </template>
          </a-table-column>
        </a-table>
        <!-- <a-form-model-item :label="$t('售后订单.是否同意')" prop="approve">
          <a-radio-group v-model="approveForm.approve" button-style="solid">
            <a-radio-button :value="true">{{ $t('通用.按钮.通过') }}</a-radio-button>
            <a-radio-button :value="false">{{ $t('通用.按钮.拒绝') }}</a-radio-button>
          </a-radio-group>
        </a-form-model-item> -->
        <a-form-model-item :label="$t('售后订单.审批意见')" prop="approvalOpinion" style="margin-bottom: 50px;">
          <a-textarea v-if="!approveReadOnly" v-model="approveForm.approvalOpinion" :placeholder="$t('通用.输入.请输入') + $t('售后订单.审批意见')" :rows="3"
            :maxLength="500" />
        </a-form-model-item>
      </a-form-model>
      <div class="bottom-control" v-if="!approveReadOnly">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitApprove(true)">
            {{ $t('通用.按钮.通过') }}
          </a-button>
          <a-button @click="submitApprove(false)" type="danger"> 
            {{ $t('通用.按钮.拒绝') }}
          </a-button>
        </a-space>
      </div>
    </a-modal>
  </page-header-wrapper>
</template>

<script>
import { pendingModifyPricePage, approveModifyPrice } from '@/api/order/sell'
// import { TableSettingMixin } from '@/mixins/TableSettingMixin'
import { tableMixin } from '@/store/table-mixin'
import moment from 'moment'

export default {
  name: 'ApprovalPrice',
  mixins: [tableMixin],
  data() {
    return {
      // 查询参数
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        id: undefined,
        buyerName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        modifyStatus: undefined
      },
      list: [],
      total: 0,
      pageSizeOptions: ['10', '20', '50', '100'],
      options:[
        {type:0,name:'待审批'},
        {type:1,name:'已通过'},
        {type:2,name:'已拒绝'},
      ],
      loading: false,
      // 审批弹窗
      approveModalVisible: false,
      submitLoading: false,
      approveReadOnly: false,
      approveRecord: {},
      approveForm: {
        id: undefined,
        approve: true,
        approvalOpinion: undefined
      },
      approveRules: {
        // approve: [
        //   { required: true, message: this.$t('售后订单.是否同意') + this.$t('通用.文本.不能为空'), trigger: 'blur' }
        // ]
      },
      // 表头
      columns: [
        {
          title: this.$t('销售订单.订单编号'),
          dataIndex: 'id',
  
        },
        {
          title: this.$t('销售订单.买家名称'),
          dataIndex: 'buyerName',
   
        },
        {
          title: this.$t('销售订单.当前金额'),
          dataIndex: 'payAmount',
          scopedSlots: { customRender: 'payAmount' },
 
        },
        {
          title: this.$t('销售订单.申请金额'),
          dataIndex: 'pendingPayAmount',
          scopedSlots: { customRender: 'pendingPayAmount' },

        },
        {
          title: this.$t('销售订单.申请备注'),
          dataIndex: 'modifyRemark',
          ellipsis: true,

        },
        {
          title: this.$t('销售订单.申请时间'),
          dataIndex: 'modifyCreateTime',
          scopedSlots: { customRender: 'createTime' },
    
        },
        {
          title: this.$t('价格审核.状态'),
          dataIndex: 'modifyStatus',
          scopedSlots: { customRender: 'modifyStatus' },

        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
      
          fixed: 'right'
        }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    moment,
    /** 查询待审批列表 */
    getList() {
      this.loading = true
      pendingModifyPricePage(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    getTotal(total) {
      return this.$t('通用.文本.共') + total + this.$t('通用.文本.条')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        id: undefined,
        buyerName: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        modifyStatus: undefined
      }
      this.getList()
    },
    /** 分页变化 */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    /** 打开审核弹窗 */
    handleApprove(record) {
      this.approveRecord = record
      this.approveForm = {
        id: record.id,
        approve: true,
        approvalOpinion: undefined
      }
      this.approveModalVisible = true
    },
    /** 关闭审核弹窗 */
    approveModalCancel() {
      this.approveModalVisible = false
      this.approveForm = {
        id: undefined,
        approve: true,
        approvalOpinion: undefined
      }
      this.approveRecord = {}
    },
    /** 提交审批 */
    submitApprove(approve) {
      this.$refs.approveForm.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          this.approveForm.approve = approve;
          approveModifyPrice(this.approveForm).then(response => {
            this.$message.success(response.msg || this.$t('售后订单.审核成功'))
            this.approveModalVisible = false
            this.getList()
          }).finally(() => {
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep(.myForm .ant-form-item){
  margin-bottom: 0px;
}
</style>